import React, { useState } from 'react';
import { Link } from 'react-router-dom'

import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Drawer from '@mui/material/Drawer';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import MobileScreenShareIcon from '@mui/icons-material/MobileScreenShare';
import PaidIcon from '@mui/icons-material/Paid';
import ComputerIcon from '@mui/icons-material/Computer';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Switch from '@mui/material/Switch';
import EditableNumber from '../components/EditableNumber'
import tableHelpers from '../helpers/TableHelpers.js'
import { useNavigate } from 'react-router-dom'

export default function BottomNav(props) {
    const navigate = useNavigate()

    const [value, setValue] = React.useState(0);
    const ref = React.useRef(null);
    const [drawerOpen, setDrawerOpen] = useState(false);

    function changeAccounts(accountId) {
        if (props.onAccountSelected)
            props.onAccountSelected(accountId);
        setDrawerOpen(false);
    }

    function navigateAccountsSummary() {
        setDrawerOpen(false);
        navigate("/accountsSummary")
    }

    function changeMobileView() {
        if (props.handleMobileViewClicked)
            props.handleMobileViewClicked();
        setDrawerOpen(false);
    }

    function updateAccountValue(value) {
        if (props.onAccountValueUpdated)
            props.onAccountValueUpdated(value)
        setDrawerOpen(false);
    }

    return (
        <>
            <Drawer
                anchor={'bottom'}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
            >
                <div style={{ padding: '30px' }}>
                    <center><b><Link onClick={() => setDrawerOpen(false)}>CLOSE</Link></b></center>
                    <br></br>
                    <center>
                        {value === 0 ?
                            <>
                                Desktop <Switch defaultChecked={props.mobileView} onChange={() => changeMobileView()} /> Mobile
                            </>
                            : null}
                        {value === 1 ? <>
                            <center>
                                <h6>Change Account:</h6>
                                <br></br>
                                <ButtonGroup orientation="vertical">
                                    {props.accounts.map(account => {
                                        return <Button color={props.activeAccountName === account.name ? 'error' : undefined} onClick={() => changeAccounts(account.idaccounts)} key={account.name}>{account.name}</Button>
                                    })}
                                    <Button onClick={() => navigateAccountsSummary()} key={"Accounts Summary"}>Accounts Summary</Button>
                                </ButtonGroup>
                                <br></br>
                                <br></br>
                                <Link to="/addAccount" onClick={() => setDrawerOpen(false)}>Manage Accounts</Link>
                            </center>
                        </> : null}
                        {value === 2 ?
                            <>
                                {props.activeAccountName}
                                <br></br>
                                Account Value: <EditableNumber hideValue={props.hideAccountValues} value={props.accountValue} onValueUpdated={updateAccountValue} length="8" />
                            </>
                            : null}
                    </center>
                </div>
            </Drawer>

            <Box ref={ref} >
                <CssBaseline />
                <Paper className={'button-footer'} elevation={0}>
                    <BottomNavigation
                        showLabels
                        value={value}
                        onChange={(event, newValue) => {
                            console.log("event", event);
                            setValue(newValue);
                            setDrawerOpen(true);
                        }}
                        sx={{ backgroundColor: '#A0DDFD' }}
                    >
                        <BottomNavigationAction label={props.mobileView ? "Mobile" : "Desktop"} icon={props.mobileView ? <MobileScreenShareIcon /> : <ComputerIcon />} />
                        <BottomNavigationAction label={props.activeAccountName} icon={<AccountBalanceIcon />} />
                        <BottomNavigationAction label={props.accountValue ? tableHelpers.moneyFormatterNoCents(props.accountValue) : "Balance"} icon={<PaidIcon />} />
                    </BottomNavigation>
                </Paper>
            </Box>
        </>
    );
}